import { usePermitFormErrors } from '@src/orders/hooks/usePermitFormErrors';
import { matchesBetween } from '@src/orders/MatchesBetween';

export const useSectionError = (fields: string[] | readonly string[]) => {
  const { formErrorKeys } = usePermitFormErrors();
  const sectionInError = matchesBetween(formErrorKeys, fields);

  return { sectionInError };
};
